import clsx from "clsx";
import { Toaster } from "react-hot-toast";

import { useDocument } from "@web-app/hooks";

import Navigation from "../common/Navigation";

import OrderTableContainer from "./OrderTableContainer";

const ManagePage = ({ logout }: { logout: () => void }) => {
  useDocument({ title: "Table View · FULFLLD" });

  return (
    <div>
      <Navigation logout={logout} />
      <Toaster position="top-center" />
      <div className="ml-20 flex h-screen">
        <main
          className={clsx(
            `w-full h-full inset-y-0 left-20 overflow-y-hidden border-gray-200 bg-gray-100 px-4 py-4 sm:px-6 lg:px-5 xl:block`,
          )}
        >
          <div className="h-full">
            <OrderTableContainer />
          </div>
        </main>
      </div>
    </div>
  );
};

export default ManagePage;
